// src/icons/StepIcon.jsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import IconaGoals from '../../importfiles/IconaGoals.png';
import IconaSensor from '../../importfiles/IconaSensor.png';
import IconaConnetivity from '../../importfiles/IconConntetivity.png';
import IconaData from '../../importfiles/IconData.png';
import IconProposal from '../../importfiles/IconProposal.png';

library.add(fas);

const CUSTOM_ICON_RULES = [
    { match: 'goal',            icon: IconaGoals },
    { match: 'sensor',          icon: IconaSensor },
    { match: 'connectivity',    icon: IconaConnetivity },
    { match: 'data_and_alerts', icon: IconaData },
    { match: 'proposals',       icon: IconProposal },
];

const FALLBACK_FA_ICON = 'circle-question';

const getStepIcon = (key = '') => {
    const normalized = key.toLowerCase();
    const rule = CUSTOM_ICON_RULES.find(r => normalized.includes(r.match));
    if (rule) return { type: 'custom', Component: rule.icon };
    const faDef = findIconDefinition({ prefix: 'fas', iconName: normalized });
    if (faDef) return { type: 'fa', iconName: normalized };
    return { type: 'fa', iconName: FALLBACK_FA_ICON };
};

export const StepIcon = ({ stepKey }) => {
    const resolved = getStepIcon(stepKey);
    if (resolved.type === 'custom') {
        const Icon = resolved.Component;
        return <img src={Icon} alt={stepKey} className="step-icon-img" />;
    }
    return <FontAwesomeIcon icon={resolved.iconName} className="step-icon-img" />;
};